import React, { useMemo, useRef } from 'react';
import {isAragUser, isSolicitorUser} from "../../helpers/functions";
import Dots from 'react-activity/lib/Dots';
import Button from "../button";
import moment from "moment";
import { LEGAL_ADVICE_TEXT, POLICYHOLDER_TEXT } from '../../helpers/variables';
import { Link, List, Modal, ModalBody, ModalContent, ModalDialog, ModalHeader } from 'arag-ui-lib';

export const ApplicationPolicyViewHeader = (props) => {
    const internalAlertField = useRef(null);
    const {UpdateTab,internalAlertsModalOpen,internalAlerts,toggleInternalAlertModal} = props;
    let userRole = props.User.loggedInUser.roles[0];
   const alertsText = internalAlerts.map( e => e.internalAlertText).join(' ; ');

   const internalAlertIsOverflow = useMemo(() =>{
       //client width is the width of the element in the view port
       //scroll width is the width of the element including the overflow
    if (internalAlertField.current) {
        return internalAlertField.current?.scrollWidth > internalAlertField.current?.clientWidth;
    }
    return false;
    },[alertsText.length,internalAlertField?.current])

    return (
        <div>
            <div className="row">
                <div className="col-xs-6">
                    <ul className={'unorderedListNoBulletsAndSpace'}>
                        { isAragUser(props.User.loggedInUser.roles) && (
                            <li>
                                {'Created By: '}
                                <strong className={'text-strong'}>
                                    {(props.SelectedApp.agentName?props.SelectedApp.agentName:'')}
                                </strong>
                            </li>
                        )}
                        { isAragUser(props.User.loggedInUser.roles) && (
                            <li>
                                {`${LEGAL_ADVICE_TEXT}: `}
                                <strong className={'text-strong'}>
                                    {(props.SelectedApp.lawsysName?props.SelectedApp.lawsysName:'')}
                                </strong>
                            </li>
                        )}
                        { isAragUser(props.User.loggedInUser.roles) && (
                            <li>
                                {`${LEGAL_ADVICE_TEXT} Group: `}
                                <strong className={'text-strong'}>
                                    {(props.SelectedApp.solicitorGroupName?props.SelectedApp.solicitorGroupName:'')}
                                </strong>
                            </li>
                        )}
                        { isAragUser(props.User.loggedInUser.roles) && (
                            <li>
                                {`${LEGAL_ADVICE_TEXT} Reference: `}
                                <strong className={'text-strong'}>
                                    {props.SelectedApp.solicitorReference}
                                </strong>
                            </li>
                        )}
                        <li>
                            {'ARAG Reference: '}
                            <strong className={'text-strong'}>
                                {props.SelectedApp.aragReference}
                            </strong>
                        </li>
                        <li>
                            {`${POLICYHOLDER_TEXT} Name: `}
                            <strong className={'text-strong'}>
                                {props.SelectedApp.clientName}
                            </strong>
                        </li>
                        {isAragUser(props.User.loggedInUser.roles) &&
                            alertsText.length > 0 &&
                            (
                                <li style={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    alignItems: 'flex-start',
                                }}>
                                    Internal Alerts: &nbsp;
                                    {internalAlerts.fetching && <Dots />}
                                    <div className={'text-strong'}
                                        ref={internalAlertField}
                                        style={{
                                            overflow: 'hidden',
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            maxWidth: '55%'
                                        }}
                                    >
                                        {alertsText}
                                    </div>
                                    {internalAlertIsOverflow &&
                                        <Link
                                            variant="tertiary"
                                            arrowDirection="left"
                                            onClick={toggleInternalAlertModal}
                                            label="View more"
                                        ></Link>
                                    }
                                </li>
                            )}
                        {internalAlertsModalOpen &&
                            <Modal fadeIn darkenedBackground>
                                <ModalDialog>
                                    <ModalContent>
                                        <ModalHeader title="Internal Alerts" onClose={toggleInternalAlertModal} />
                                        <ModalBody>
                                            <List
                                                items={internalAlerts.map(c => { return { content: c.internalAlertText } })}
                                            />

                                        </ModalBody>
                                    </ModalContent>
                                </ModalDialog>
                            </Modal>}
                        {(
                            isAragUser(props.User.loggedInUser.roles)
                            && props.SelectedApp
                            && props.SelectedApp.policyStatus
                            && (
                                props.SelectedApp.policyStatus.toLowerCase() === "abandoned"
                                || props.SelectedApp.policyStatus.toLowerCase() === "closed"
                                || props.SelectedApp.policyStatus.toLowerCase() === "won – part 36 late acceptance"
                            )
                        ) && (
                            [
                                props.SelectedApp.lawsysCaseReference ?
                                    <li key={0}>
                                        {'Lawsys Case Reference: '}
                                        <strong className={'text-strong'}>
                                            {props.SelectedApp.lawsysCaseReference}
                                        </strong>
                                    </li> : null,
                                props.SelectedApp.lawsysCaseDate ?
                                    <li key={1}>
                                        {'Lawsys Case Date: '}
                                        <strong className={'text-strong'}>
                                            {moment(props.SelectedApp.lawsysCaseDate).format("DD/MM/YYYY")}
                                        </strong>
                                    </li> : null
                            ]
                        )}
                    </ul>
                </div>
                <div className="col-xs-6">
                    <div className="row">
                        <div className="col-xs-12 applicationPolicy-status-wrapper">
                            <span className="applicationPolicy-status-span-2">
								{props._getPolicyStatusLabel()}
							</span>
                            <span className="applicationPolicy-status-span-1">Status: </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row noprintarea">
                <div className="col-sm-5">
                {((userRole !== 'Solicitor' && (props.Store.notification!=null?props.Store.notification.id:0) > 0 && props.Store.notification.applicationId === props.SelectedApp.id && !props.SelectedApp.readByArag ) || (userRole === 'Solicitor' && ((props.Store.notification!=null?props.Store.notification.id:0) > 0) && (props.Store.notification.eventName === 'Status Changed')))  ?                        
                        <div>
                            <Button
                                clickHandler={() => props.requestPatchNotification(props.Store.notification.id, true, props.SelectedApp.id)}
                                wrapper="btn-wrapper" btnType="button"
                                btnStyle={'btn btn-primary btn-xs sharp yellow'} label="Mark As Viewed"/>
                            {
                                props.Store.updatingNotification ?
                                    <Dots />
                                    :
                                    null
                            }
                        </div>
                        :
                        null
                    }
                </div>
                <div className="col-sm-7">
                    {
                        userRole !== 'Solicitor' ?
                            <Button
                                clickHandler={() => props.ChangeApplicationPolicySettings('openModal', true)}
                                wrapper="btn-wrapper-changeStatus" btnType="button"
                                btnStyle={'btn btn-primary btn-xs sharp yellow'} label="Change Status"/>
                            :
                            null
                    }
                </div>
                {isSolicitorUser(props.User.loggedInUser.roles) &&
                    <div className="col-sm-7">
                        {UpdateTab.costsSummary !== '' &&
                            UpdateTab.fetchingCostsSummary == false &&
                            <Button
                                clickHandler={() => props.toggleCostsSummaryModal()}
                                wrapper="btn-wrapper" btnType="button"
                                btnStyle={'btn btn-primary btn-xs sharp yellow'} label="Costs Summary" />}

                        {UpdateTab.fetchingCostsSummary && <Dots />}
                    </div>

                }
            </div>
            <div className="row noprintarea">
                <div className="col-sm-12">
                    {
                        isAragUser(props.User.loggedInUser.roles) && (
                            <Button
                                clickHandler={() => 
                                {
                                    props.handleSolicitorFirmSelect(props.SelectedApp.lawsysId);
                                    props.handleSolicitorSelect(props.SelectedApp.applicationUserId);
                                    props.TransferApplicationBetweenSolicitorUsers('openTransferApplicationModal', true);
                                }}
                                wrapper="btn-wrapper" btnType="button"
                                btnStyle={'btn btn-primary btn-xs sharp yellow'} label="Transfer Case"/>
                        )
                    }
                </div>
            </div>
        </div>
    )
};

export default ApplicationPolicyViewHeader;